// Copyright (c) 2017 Deere & Company

import actions from '../../action-list';
import {readClaims} from './read-claims';

export const updateClaimStatus = status =>

    (dispatch, getState) => {

        dispatch({
            status,
            type: actions.UPDATE_CLAIMS_IN_PROGRESS_STATUS
        });

        readClaims(status)(dispatch, getState);

    };

export const resetClaimsInProgress = () => ({
    type: actions.RESET_CLAIMS_IN_PROGRESS
});



// WEBPACK FOOTER //
// ./src/claim/claims-in-progress/action-creators/select-status.js